var coinsService = function () {
  this.add = function (model) {
    if (window.localStorage.getItem("rdp-super-app-coins") === null) {
      window.localStorage.setItem("rdp-super-app-coins", "[]");
    };
    var data = JSON.parse(window.localStorage.getItem("rdp-super-app-coins"));
    data.push(model);

    window.localStorage.setItem("rdp-super-app-coins", JSON.stringify(data));
  }

  this.exist = function(type, target) {
    var data = JSON.parse(window.localStorage.getItem("rdp-super-app-coins"));

    return data.filter(item => item.type === type && item.target === target).length > 0;
  }

  return this;
}

var CoinsService = new coinsService();

export {
  CoinsService
};